import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faTrash, faQuestionCircle, faBuilding, faStore, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext';
import { addArea, createFloor, deleteFloor, listFloor, viewFloor } from '../Network/Floor'
import "./Floor.css"
import { AlertModalContext } from '../Library/AlertModalContext';
import { Loading } from '../Library'

function Floor() {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.floor

    const [isLoading, setIsLoading] = useState(false)
    const [floorList, setFloorList] = useState([])
    const [currentSelectFloor, setCurrentSelectFloor] = useState(null)
    const [selectedData, setSelectedData] = useState(null)
    const [listArea, setListArea] = useState([])

    const [areaDesc, setAreaDesc] = useState("")
    const [areaSize, setAreaSize] = useState("")
	const [maxLease, setMaxLease] = useState(0)
    const [isAddingArea, setIsAddingArea] = useState(false)

    const [newFloorError, setNewFloorError] = useState(false)
    const [newFloor, setNewFloor] = useState("")

    const FloorItem = ({ id, floorName, data, count, isSelected }) => {
        return(
            <div 
            className={`floor-item ${isSelected ? 'floor-item-active': ''}`}
            onClick={()=>{
                setCurrentSelectFloor(id)
                getFloorDetail(id)
                setSelectedData(data)
            }}
            >
                <div style={{ flex: 1 }}>
                    <div className='floor-title'>{lang.floor} {floorName}</div>
                    {/* <div className='floor-desc'
                    style={{ color: isSelected ? 'white': 'gray' }}>
                        {count || 0} {lang.companies}
                    </div> */}
                </div>
                <div>
                    <Button 
                    size="sm" variant="danger"
                    onClick={(e)=>{
                        e.preventDefault()
                        onDeleteFloor(id)
                    }}
                    >
                        <FontAwesomeIcon icon={faTrash}/>
                    </Button>
                </div>
            </div>
           
        )
    }

    const AreaItem = ({ areaDesc, areaSize, maxLease, totalLeased, availableLease }) => {
        return(
            <div className='area-item'>
                <div>
                    <b>{areaDesc}</b>
                </div>
                <div>
                    <div>{areaSize}</div>
                </div>
                <div>
                    {lang.total_rent} : {maxLease}
                </div>
                <div>
                    {lang.available} : {availableLease}
                </div>
            </div>
        )
    }

    const CompanyItem = ({name, nameEn, type}) => {
        let typeIcon = { icon: faQuestionCircle, color: 'gray' }
        switch(type){
            case("OFFICE"):
                typeIcon = { icon: faBuilding, color: 'green' }
                break
            case("RETAIL"):
                typeIcon = { icon: faStore, color: 'orange' }
                break
        }

        return(
            <div className='company-item'>
                <FontAwesomeIcon icon={typeIcon.icon} color={typeIcon.color} className='icon'/>
                <div>
                    <div className='company-title'>{name || '-'}</div>
                    <div className='company-desc'>{nameEn || '-'}</div>
                </div>
            </div>
        )
    }

	const addAreaToFloor = () => {
		console.log(currentSelectFloor)
		addArea(areaDesc, areaSize, maxLease, currentSelectFloor)
		.then(() => {
			setAreaDesc("")
			setAreaSize("")
			setMaxLease(0)
			getFloorDetail(currentSelectFloor)
			setIsAddingArea(false)
		})
		.catch(() => {

		})
	}

    const getFloorDetail = (floorId) => {
        viewFloor(floorId)
        .then((data) => {
            setListArea(data.listArea)
        })
        .catch((error) => {

        })
    }

    const fetchData = () => {
        setIsLoading(true)
        listFloor(
            (data)=>{ 
                setFloorList(data) 
                setIsLoading(false)
            },
            (error) => {  }
        )
    }

    const onCreateFloor = () => {
        if(!newFloor){
            setNewFloorError(true)
            return
        }

        setIsLoading(true)
        createFloor(newFloor,
            ()=>{ 
                fetchData() 
                setNewFloor("")
                setNewFloorError(false)
            },
            (error)=>{ setIsLoading(false) })
    }

    const onDeleteFloor = (floorId) => {
        alertModal.setTitle(lang.delete_floor)
        alertModal.setDescription(lang.sure_to_delete_floor)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    setIsLoading(true)
                    deleteFloor(floorId,
                        ()=>{
                            fetchData()
                            setIsLoading(false)
                        },
                        ()=>{
                            setIsLoading(false)
                        })
                    alertModal.setIsShow(false)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        
    }

    useEffect(()=>{
        fetchData()
    },[])

    return(
        <div id="floor">
            { isLoading ? <Loading/>: null }
            <div style={{ marginBottom: 23 }}>{lang.to_add_company}</div>
            <Row>
                <Col md={5}>
                    <div className='floor-container'>
                        <div className='add-floor'>
                            <Form.Control
                            placeholder={lang.type_floor}
                            value={newFloor}
                            isInvalid={newFloorError && !newFloor}
                            onChange={(e)=>setNewFloor(e.target.value)}
                            />
                            <Button variant="success" size="sm" onClick={()=>onCreateFloor()}>
                                +
                            </Button>
                        </div>
                        { floorList.map((item, key) =>
                        <FloorItem
                        key={key}
                        id={item.id}
                        floorName={item.floorName}
                        data={item}
                        count={item.listCompanies.length}
                        isSelected={currentSelectFloor === item.id ? true :false}
                        />
                        )}
                    </div>
                </Col>
                <Col md={7}>
                    <div className='floor-container'>
                        { currentSelectFloor !== null ?
                        <div className='floor-detail'>
                            <div className='title'>{lang.list_area}</div>
                            { listArea.map((item, key) =>
                            <AreaItem
                            key={key}
                            areaDesc={item.areaDesc}
                            areaSize={item.areaSize}
                            totalLeased={item.totalLease}
                            availableLease={item.availableLease}
                            maxLease={item.maxLease}
                            />
                            )}
                            { !isAddingArea &&
                            <div className='add-area' onClick={()=>setIsAddingArea(true)}>
                                <FontAwesomeIcon icon={faPlusCircle}/>
                                <span style={{ marginLeft: 8 }}>{lang.add_area}</span>
                            </div>
                            }
                            { isAddingArea &&
                            <Form className='adding-area'>
                                <Form.Group>
                                    <Form.Label>{lang.area_desc}</Form.Label>
									<Form.Control
									value={areaDesc}
									onChange={(e)=>setAreaDesc(e.target.value)}
									/>
                                </Form.Group>
								<Form.Group>
                                    <Form.Label>{lang.area_size}</Form.Label>
									<Form.Control
									value={areaSize}
									onChange={(e)=>setAreaSize(e.target.value)}
									/>
                                </Form.Group>
								<Form.Group>
                                    <Form.Label>{lang.total_rent}</Form.Label>
									<Form.Control 
									value={maxLease}
									onChange={(e)=>setMaxLease(e.target.value)}
									min={0}
									type='number'/>
                                </Form.Group>
								<div className='add-btn'>
									<Button
									disabled={!areaDesc || !areaSize || maxLease <= 0}
									onClick={()=>addAreaToFloor()}
									>
										{lang.add_area}
									</Button>
									<Button 
									variant='secondary'
									style={{ marginLeft: 8 }}
									onClick={()=>setIsAddingArea(false)}>
										{lang.cancel}
									</Button>
								</div>
                            </Form>
                            }
                        </div>
                        : 
                        <div className='non-select-floor'>
                            <FontAwesomeIcon icon={faLayerGroup} className='icon'/>
                            <div>{lang.choose_floor}</div>
                        </div>
                        }
                    </div>
                </Col>
            
            </Row>
        </div>
    )
}

export default Floor;
